export class DownloadUtil {
    static handleFileDownload(response) {
        let blob = new Blob([response.data], response.headers);
        let url = URL.createObjectURL(blob);
        let hyperlink = document.createElement("a");
        if (typeof hyperlink.download === "undefined")
            window.location.href = url;
        else {
            hyperlink.href = url;
            if (response.fileName)
                hyperlink.download = response.fileName;
            document.body.appendChild(hyperlink);
            hyperlink.click();
            if (hyperlink.parentNode)
                hyperlink.parentNode.removeChild(hyperlink);
        }
    }
    ;
    static downloadFile(blob, fileName) {
        try {
            if (typeof navigator.msSaveBlob === "function") {
                navigator.msSaveBlob(blob, fileName);
                return;
            }
            let hyperlink = document.createElement("a");
            if (typeof hyperlink.download === "undefined")
                return;
            let url = URL.createObjectURL(blob);
            hyperlink.setAttribute("href", url);
            hyperlink.setAttribute("download", fileName);
            hyperlink.style.visibility = "hidden";
            document.body.appendChild(hyperlink);
            hyperlink.click();
            document.body.removeChild(hyperlink);
        }
        catch (ex) {
            console.error(ex);
        }
    }
}
